import React, { useState, useEffect, useRef } from 'react';
import { useNavbarData } from '../useNavbarData';
import { CollapsedNavbar } from '../CollapsedNavbar';
import { ExpandedNavbar } from '../ExpandedNavbar';
import { NavBarItemType } from '../types';
import './index.scss';
import { useSelector } from 'react-redux';

type Props = {
  activePath: string;
};

export const NavbarV2 = (props: Props) => {
  const { activePath } = props;
  const [attId, setAttId] = useState(localStorage.getItem('att-id'));
  const [expandedVisible, setExpandedVisible] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const trialPeriod = useSelector((state: any) => state.user?.trialPeriod);
  const userTenantType = useSelector((state: any) => state.user?.userTenantType);

  // Track if mouse is currently hovering over navbar
  const isHoveringNavbarRef = useRef(false);

  // Refs to store popover close functions
  const closeProfilePopoverRef = useRef<(() => void) | null>(null);
  const closeNotificationsPopoverRef = useRef<(() => void) | null>(null);

  const { navDataV2 } = useNavbarData(activePath);

  useEffect(() => {
    const checkAttId = () => {
      const newAttId = localStorage.getItem('att-id');
      if (newAttId && newAttId !== attId) {
        setAttId(newAttId);
        clearInterval(intervalId);
      }
    };

    const intervalId = setInterval(checkAttId, 300);

    return () => clearInterval(intervalId);
  }, [attId]);

  useEffect(() => {
    // Close popovers and collapse navbar on navigation
    if (closeProfilePopoverRef.current) {
      closeProfilePopoverRef.current();
    }
    if (closeNotificationsPopoverRef.current) {
      closeNotificationsPopoverRef.current();
    }
    setIsPopoverOpen(false);
    setExpandedVisible(false);
  }, [activePath]);

  useEffect(() => {
    // Collapse navbar when popover closes and mouse is not hovering
    if (!isPopoverOpen && !isHoveringNavbarRef.current) {
      setExpandedVisible(false);
    }
  }, [isPopoverOpen]);

  const shouldDisplayDivider = (group: NavBarItemType[]) => {
    const hasConditionTrue = group.some((item) => item.displayCondition);
    const hasMultipleItems = group.length >= 1;
    return hasConditionTrue && hasMultipleItems;
  };

  const handleMouseEnter = () => {
    isHoveringNavbarRef.current = true;
    setExpandedVisible(true);
  };

  const handleMouseLeave = () => {
    isHoveringNavbarRef.current = false;
    // Don't collapse navbar if a popover is open
    if (isPopoverOpen) {
      return;
    }
    setExpandedVisible(false);
  };

  const handleCloseNavbar = () => {
    console.log('isHovering', isHoveringNavbarRef.current);
    setExpandedVisible(false);
  };

  return (
    <div
      className="navbar-v2-sidebar-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CollapsedNavbar
        navData={navDataV2}
        shouldDisplayDivider={shouldDisplayDivider}
        trialPeriod={trialPeriod}
        userTenantType={userTenantType}
      />
      <ExpandedNavbar
        navData={navDataV2}
        shouldDisplayDivider={shouldDisplayDivider}
        isVisible={expandedVisible}
        onMouseLeave={handleMouseLeave}
        triggerCollapse={handleCloseNavbar}
        closeProfilePopoverRef={closeProfilePopoverRef}
        closeNotificationsPopoverRef={closeNotificationsPopoverRef}
        setIsPopoverOpen={setIsPopoverOpen}
        trialPeriod={trialPeriod}
        userTenantType={userTenantType}
      />
    </div>
  );
};
